<div class="k-loading-panel" *ngIf="loadingService.loadingObservable$ | async">
  <div class="k-loading-panel-mask"></div>
  <div class="k-loading-panel-wrapper">
    <kendo-loader type="converging-spinner" size="large"> </kendo-loader>
  </div>
</div>
